import React from 'react';
import PropTypes from 'prop-types';
import { LinearProgress, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function LinearProgressLabel({ quarter }) {
  const { t, i18n } = useTranslation();

  const endOfQuarter = quarter?.endDate ? new Date(quarter.endDate) : null;
  const startOfQuarter = quarter?.startDate ? new Date(quarter.startDate) : null;

  const daysLeft = endOfQuarter ? Math.ceil((endOfQuarter.getTime() - Date.now()) / (1000 * 60 * 60 * 24)) : null;
  const daysCompleted = startOfQuarter ? Math.ceil((Date.now() - startOfQuarter.getTime()) / (1000 * 60 * 60 * 24)) : null;

  const daysInQuarter = endOfQuarter
    ? Math.ceil((endOfQuarter.getTime() - startOfQuarter.getTime()) / (1000 * 60 * 60 * 24))
    : null;
  const normalise = daysLeft => ((daysLeft - 1) * 100) / (daysInQuarter - 1);

  const formatDate = date => {
    return date ? date.toLocaleDateString(i18n.language, { year: 'numeric', month: 'short', day: 'numeric' }) : '';
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
      <Typography variant="h6" sx={{ mb: 0.5, textAlign: 'center' }}>
        {quarter.internalName}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', width: '75%' }}>
        <Typography variant="caption" sx={{ mr: 1, minWidth: 80, textAlign: 'right' }}>
          {formatDate(startOfQuarter)}
        </Typography>
        <Box sx={{ flex: 2 }}>
          <LinearProgress sx={{ height: 20, borderRadius: 5 }} variant="determinate" value={normalise(daysCompleted)} />
        </Box>
        <Typography variant="caption" sx={{ ml: 1, minWidth: 80 }}>
          {formatDate(endOfQuarter)}
        </Typography>
      </Box>
      <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.25 }}>
        {t('home.daysLeft', { days: daysLeft })}
      </Typography>
    </Box>
  );
}

LinearProgressLabel.propTypes = {
  quarter: PropTypes.shape({
    internalName: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }).isRequired,
};
